export const globalColor = {
    bgPrimary: '#1D1B29',
    bgSecondary: '#3D3D3D',
    textPrimary: '#fff',
    notActiveText: '#7C7C7C', // text not active
    textLinear: 400,
    textSemiBold: 600,
    textBold: 700,
}